module.exports = __webpack_public_path__ + "img/nostock.7450c390.png";